module.exports = __webpack_public_path__ + "img/c9b19f3.jpg";